/*
 * India public holidays, 2026.
 *
 * Fixed-date entries (Republic Day, Independence Day, Gandhi Jayanti,
 * Christmas, New Year, Good Friday) are exact. Festival dates that follow
 * the lunar or Islamic calendar - Holi, Ugadi, both Ids, Vinayaka Chavithi,
 * Dussehra, Diwali - can shift by a day and vary by state, so confirm them
 * against the company's declared calendar before publishing.
 *
 * Every dayOfWeek below was computed from its own date.
 */
export const holidayList = [
    {
        "id": 1,
        "holiday": "New Year's Day",
        "date": "01/01/2026",
        "dayOfWeek": "Thursday"
    },
    {
        "id": 2,
        "holiday": "Makar Sankranti / Pongal",
        "date": "14/01/2026",
        "dayOfWeek": "Wednesday"
    },
    {
        "id": 3,
        "holiday": "Republic Day",
        "date": "26/01/2026",
        "dayOfWeek": "Monday"
    },
    {
        "id": 4,
        "holiday": "Holi",
        "date": "04/03/2026",
        "dayOfWeek": "Wednesday"
    },
    {
        "id": 5,
        "holiday": "Ugadi",
        "date": "19/03/2026",
        "dayOfWeek": "Thursday"
    },
    {
        "id": 6,
        "holiday": "Id-ul-Fitr (Ramzan)",
        "date": "20/03/2026",
        "dayOfWeek": "Friday"
    },
    {
        "id": 7,
        "holiday": "Good Friday",
        "date": "03/04/2026",
        "dayOfWeek": "Friday"
    },
    {
        "id": 8,
        "holiday": "Bakrid (Id-ul-Zuha)",
        "date": "27/05/2026",
        "dayOfWeek": "Wednesday"
    },
    {
        "id": 9,
        "holiday": "Independence Day",
        "date": "15/08/2026",
        "dayOfWeek": "Saturday"
    },
    {
        "id": 10,
        "holiday": "Vinayaka Chavithi",
        "date": "14/09/2026",
        "dayOfWeek": "Monday"
    },
    {
        "id": 11,
        "holiday": "Gandhi Jayanti",
        "date": "02/10/2026",
        "dayOfWeek": "Friday"
    },
    {
        "id": 12,
        "holiday": "Dussehra",
        "date": "20/10/2026",
        "dayOfWeek": "Tuesday"
    },
    {
        "id": 13,
        "holiday": "Diwali",
        "date": "08/11/2026",
        "dayOfWeek": "Sunday"
    },
    {
        "id": 14,
        "holiday": "Christmas",
        "date": "25/12/2026",
        "dayOfWeek": "Friday"
    }
]
